import { BRAIN_RULES, TRAIN_ROWS, TrainElvaView } from '@elva/ui';
import { useWorkspaceLabel } from '@elva/platform';
import { useNavigate } from 'react-router-dom';

/** AI Brain › Train ELVA — Your rules first (amendment 32 §3). The queues have no API — stage's mock. */
export function SettingsTrainElvaPage() {
  const location = useWorkspaceLabel();
  const navigate = useNavigate();
  return (
    <TrainElvaView
      rows={TRAIN_ROWS}
      rules={BRAIN_RULES}
      location={location}
      onWriteEntry={(question) => {
        void navigate(`/settings/ai/knowledge-base?question=${encodeURIComponent(question)}`);
      }}
      onFixEntry={(entryTitle) => {
        void navigate(`/settings/ai/knowledge-base?entry=${encodeURIComponent(entryTitle)}`);
      }}
      onChangeBooking={() => {
        void navigate('/settings/appointment-reasons');
      }}
      onMoveRuleToKb={(sentence, category) => {
        void navigate(`/settings/ai/knowledge-base?body=${encodeURIComponent(sentence)}&title=${encodeURIComponent('First missed visit')}&category=${category}`);
      }}
    />
  );
}
